const options = {
  5: "bg-gray-100/5",
  10: "bg-gray-100/10",
  25: "bg-gray-100/25",
  50: "bg-gray-100/50",
  75: "bg-gray-100/75",
  90: "bg-gray-100/90",
  100: "bg-gray-100",
};

const from = {
  5: "from-gray-100/5",
  10: "from-gray-100/10",
  25: "from-gray-100/25",
  50: "from-gray-100/50",
  75: "from-gray-100/75",
  90: "from-gray-100/90",
  100: "from-gray-100",
};

export default function getBackgroundGray100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
